import { InMemoryCache } from './InMemoryCache';
import { SessionStorageCache } from './SessionStorageCache';
import { VersionHistory } from './types';

export class SgVersionCacheFactory {
  static createCache<T>(
    useSessionStorage: boolean,
    cacheLimit: number,
  ): VersionHistory<T> {
    if (useSessionStorage) {
      return new SessionStorageCache<T>(cacheLimit);
    } else {
      return new InMemoryCache<T>(cacheLimit);
    }
  }
}
